const normalizeText = text => {
  if (!text) return '';

  const lowerWords = ['de', 'da', 'do', 'das', 'dos', 'e', 'na', 'no', 'nas', 'nos'];
  const romanNumerals = [
    'i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x',
    'xi', 'xii', 'xiii', 'xiv', 'xv', 'xvi', 'xvii', 'xviii', 'xix', 'xx',
  ];

  return text
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word, index) => {
      // Keep prepositions lowercase if they are not the first word
      if (index !== 0 && lowerWords.includes(word)) {
        return word;
      }

      // Format roman numerals up to XX
      if (romanNumerals.includes(word)) {
        return word.toUpperCase();
      }

      // Process individual parts to handle "d'" prefix correctly
      const processPart = part => {
        if (part.startsWith('d\'') && part.length > 2) {
          return `d'${part.charAt(2).toUpperCase()}${part.slice(3)}`;
        }
        return part.charAt(0).toUpperCase() + part.slice(1);
      };

      // Ensure parts around a hyphen are capitalized individually
      if (word.includes('-')) {
        return word.split('-').map(processPart).join('-');
      }

      return processPart(word);
    })
    .join(' ');
};

export default normalizeText;
